import React from 'react';

const QrCodeContext = React.createContext();

export default QrCodeContext;
